import React from 'react';
import logo from './logo.svg';
import './App.css';
import { BluetoothTester } from './components/BluetoothTester';

function App() {
  return (
    <div className="App">
      <BluetoothTester/>
    </div>
  );
}

export default App;
